<template lang="pug">
.list-ove-container
  // Header Desktop
  .header-ove.d-none.d-md-flex
    .title-section
      b-icon.back-arrow(icon="arrow-left-square-fill" @click="$router.go(-1)")
      h4.title Oportunidad de Venta de Equipos
    .actions-section
      b-dropdown.dropdown-new-quote(variant="primary" no-caret right)
        template(#button-content="")
          span.primary-btn Nueva Cotización
          b-icon.ml-2(icon="chevron-down")
        b-dropdown-item(@click="goToCreate")
          | Registrar nueva
      OVSearchInput.ml-2(
        v-model="paramsSearch"
        @search="buscar"
        :loading="loadingTable"
        @clearParamsSearch="paramsSearch = ''; buscar()"
        desktop
      )

  // Breadcrumbs
  .breadcrumbs-ove
    span.text-muted Inicio / 
    span.text-dark Oportunidad de Venta de Equipos

  // Tabs de Filtro
  .tabs-wrapper
    .custom-tabs
      .tab-item(
        v-for="estado in estados"
        :key="estado.estado"
        :class="{ active: tabNameSelected === estado.estado }"
        @click="onTabChange(estado.estado)"
      )
        span.tab-label {{ getEstadoLabel(estado.estado) }} ({{ estado.cantidad }})

  // Tabla
  .table-wrapper
    b-table(
      id="ove-table"
      :items="items"
      :fields="fields"
      hover
      responsive
      :busy="loadingTable"
      @sort-changed="sortingChanged"
      :sort-by.sync="sortBy"
      :sort-desc.sync="sortDesc"
      no-local-sorting
    )
      template(#table-busy="")
        .text-center.p-3
          b-spinner.mr-2(small)
          span Cargando datos...

      template(#cell(id)="data")
        span.id-link(@click="verDetalle(data.item.id)") {{ data.item.id }}

      template(#cell(created_at)="data")
        span {{ data.item.created_at | formatedDate }}

      template(#cell(nombre_cliente)="data")
        span {{ data.item.nombre_cliente }}

      template(#cell(estado)="data")
        StatusBadgeOVE(:status="data.item.estado")

      template(#cell(monto_total_final)="data")
        span {{ data.item.monto_total_final | formatCurrency }}

      template(#cell(monto_con_descuento)="data")
        span.font-weight-bold {{ data.item.monto_total_final | formatCurrency }}

      template(#cell(acciones)="data")
        .d-flex.justify-content-center
          b-dropdown.btn-actions-ove(variant="primary" no-caret right boundary="viewport" :disabled="loadingTable")
            template(#button-content="")
              .d-flex.align-items-center
                img.mr-2(src="@/assets/icons/actions.svg" alt="Acciones" style="width: 20px; height: 20px")
                span Acciones
            b-dropdown-item(@click="verDetalle(data.item.id)") Ver Detalle
            b-dropdown-item(v-if="data.item.estado === 'cotizacion_enviada'" @click="handlePagarCotizacion(data.item.id)") Pagar Cotización
            b-dropdown-item(v-if="data.item.estado === 'cotizacion_enviada'" @click="handleRechazarCotizacion(data.item.id)") Rechazar Cotización
            b-dropdown-item(v-if="data.item.estado === 'vencida'" @click="handleReactivarCotizacion(data.item.id)") Reactivar Cotización
            b-dropdown-item(v-if="['cotizacion_enviada', 'vencida'].includes(data.item.estado)" @click="handleRecalcularTotales(data.item.id)") Recalcular Totales

    // Paginación
    .pagination-wrapper(v-if="totalRows > 0")
      b-pagination(
        v-model="currentPage"
        :total-rows="totalRows"
        :per-page="pageSize"
        align="right"
        prev-text="Ant."
        next-text="Sig."
        @change="handlePageChange"
      )

  // Empty State
  .empty-state(v-if="showEmptyData")
    .text-center.p-5
      h5 No se encontraron oportunidades de venta
      p Puedes crear una nueva desde el botón superior.

  StockValidationModal(
    ref="stockModal"
    :equipments="equipmentsSinStock"
    :oveId="selectedOveId"
    :context="stockModalContext"
  )

  RejectOVEModal(
    ref="rejectModal"
    :ovedetail="selectedOveDetail"
    @rejected="onOveRejected"
  )
</template>

<script>
import { mapActions } from 'vuex'
import StatusBadgeOVE from './StatusBadgeOVE.vue'
import OVSearchInput from '../OV/OVSearchInput.vue'
import StockValidationModal from './StockValidationModal.vue'
import RejectOVEModal from './RejectOVEModal.vue'
import { backUrl } from '../../../settings'

export default {
  name: 'ListOVE',
  components: {
    StatusBadgeOVE,
    OVSearchInput,
    StockValidationModal,
    RejectOVEModal,
  },
  data() {
    return {
      paramsSearch: '',
      loadingTable: false,
      sortBy: null,
      sortDesc: false,
      currentPage: 1,
      pageSize: 21,
      items: [],
      estados: [],
      tabNameSelected: 'cotizacion_enviada',
      totalRows: 0,
      showEmptyData: false,
      equipmentsSinStock: [],
      selectedOveId: '',
      selectedOveDetail: {},
      stockModalContext: 'pagar',
      fields: [
        { key: 'id', label: 'ID', sortable: true },
        { key: 'created_at', label: 'Fecha de creación', sortable: true },
        { key: 'nombre_cliente', label: 'Cliente', sortable: true },
        {
          key: 'correo_cliente',
          label: 'Correo Electrónico',
          sortable: true,
        },
        { key: 'telefono', label: 'Teléfono', sortable: true },
        { key: 'estado', label: 'Estado', sortable: true },
        { key: 'monto_total_final', label: 'Monto Total', sortable: true },
        {
          key: 'monto_con_descuento',
          label: 'Monto c. Dcto.',
          sortable: false,
        },
        { key: 'acciones', label: 'Acciones', class: 'text-center' },
      ],
    }
  },
  methods: {
    ...mapActions('OVEStore', [
      'listOveAll',
      'getEstadosOVE',
      'getOveDetail',
      'reactivarOve',
      'recalcularOve',
    ]),

    getEstadoLabel(estado) {
      if (estado === 'Todas') return 'Todas'
      const labels = {
        cotizacion_enviada: 'Cotización Enviada',
        oportunidad_cerrada: 'Op. Cerrada',
        oportunidad_rechazada: 'Op. Rechazada',
        vencida: 'Vencida',
      }
      return labels[estado] || estado
    },

    async buscar() {
      this.currentPage = 1
      await this.fetchData()
    },

    async getEstados() {
      try {
        const res = await this.getEstadosOVE()
        this.estados = res
      } catch (error) {
        console.error('Error al obtener estados OVE:', error)
      }
    },

    async fetchData() {
      this.loadingTable = true
      this.showEmptyData = false
      const ordering = this.sortBy
        ? `${this.sortDesc ? '-' : ''}${this.sortBy}`
        : null
      try {
        const res = await this.listOveAll({
          page: this.currentPage,
          estado: this.tabNameSelected,
          search: this.paramsSearch,
          ordering,
        })
        this.items = res.results
        this.totalRows = res.count
        this.showEmptyData = this.items.length === 0
      } catch (error) {
        console.error('Error al cargar OVEs:', error)
        this.items = []
        this.totalRows = 0
        this.showEmptyData = true
      } finally {
        this.loadingTable = false
      }
    },

    onTabChange(tabName) {
      this.tabNameSelected = tabName
      this.currentPage = 1
      this.fetchData()
    },

    handlePageChange(page) {
      this.currentPage = page
      this.fetchData()
    },

    sortingChanged(context) {
      if (context) {
        this.sortBy = context.sortBy
        this.sortDesc = context.sortDesc
      }
      this.currentPage = 1
      this.fetchData()
    },

    async handlePagarCotizacion(id) {
      this.loadingTable = true
      this.selectedOveId = id
      this.stockModalContext = 'pagar'
      try {
        const res = await this.$store.dispatch('OVEStore/verificarStock', id)
        if (res.hay_stock) {
          this.$router.push(`/oportunidad-venta-equipo/${id}/pagar`)
        } else {
          this.equipmentsSinStock = res.equipos_sin_stock
          this.$refs.stockModal.show()
        }
      } catch (error) {
        console.error('Error al verificar stock:', error)
        this.$bvToast.toast('Error al verificar stock', { variant: 'danger' })
      } finally {
        this.loadingTable = false
      }
    },

    async handleRechazarCotizacion(id) {
      this.loadingTable = true
      try {
        const detail = await this.getOveDetail(id)
        this.selectedOveDetail = detail
        this.$refs.rejectModal.show()
      } catch (error) {
        console.error('Error al obtener detalle para rechazo:', error)
        this.$bvToast.toast('Error al obtener detalle de la cotización', {
          variant: 'danger',
        })
      } finally {
        this.loadingTable = false
      }
    },

    async onOveRejected() {
      await this.getEstados()
      await this.fetchData()
    },

    async handleRecalcularTotales(id) {
      if (this.loadingTable) return
      this.loadingTable = true
      try {
        await this.recalcularOve(id)
        await this.fetchData()
        this.$bvToast.toast(
          'Totales recalculados y cotización PDF actualizada',
          {
            variant: 'success',
          }
        )
      } catch (error) {
        this.$bvToast.toast(
          error.response?.data?.error || 'Error al recalcular la cotización',
          { variant: 'danger' }
        )
      } finally {
        this.loadingTable = false
      }
    },

    async handleReactivarCotizacion(id) {
      this.loadingTable = true
      this.selectedOveId = id
      try {
        await this.reactivarOve({ ove_id: id })
        this.$toast.success(
          '¡Cotización reactivada con éxito!\nSu nueva vigencia es de 24 horas.',
          {
            timeout: 4000,
            hideProgressBar: true,
            closeButton: 'button',
            icon: true,
          }
        )
        await this.getEstados()
        await this.fetchData()
      } catch (error) {
        console.error('Error al reactivar OVE:', error)
        if (error.response && error.response.status === 409) {
          this.stockModalContext = 'reactivar'
          this.equipmentsSinStock = error.response.data.equipos_sin_stock || []
          this.$refs.stockModal.show()
        } else {
          this.$bvToast.toast('Error al reactivar la cotización', {
            variant: 'danger',
          })
        }
      } finally {
        this.loadingTable = false
      }
    },

    goToCreate() {
      this.$router.push('/oportunidad-venta-equipo/nueva')
    },

    verDetalle(id) {
      this.$router.push(`/oportunidad-venta-equipo/${id}`)
    },
    handleEdit(id) {
      this.$router.push(`/oportunidad-venta-equipo/${id}/editar`)
    },
    handleDelete(id) {
      this.$bvToast.toast(
        `Acción "Eliminar" para OVE ${id} no implementada todavía en el servidor.`,
        {
          variant: 'info',
          title: 'Información',
        }
      )
    },
    pdfUrl(pdf) {
      if (!pdf) return '#'
      return `${backUrl}${pdf}`
    },
  },
  async mounted() {
    await this.getEstados()
    await this.fetchData()
  },
}
</script>

<style lang="scss" scoped>
@import '@/style/colors.scss';

.list-ove-container {
  padding: 20px;
  background-color: #f5f6fa;
  min-height: 100vh;
}

.header-ove {
  display: flex;
  justify-content: space-between;
  align-items: center;
  // margin-bottom: 10px;
  height: 4rem;

  .title-section {
    display: flex;
    align-items: center;
    gap: 15px;

    .back-arrow {
      color: $samtek-yellow;
      font-size: 32px;
      cursor: pointer;
    }

    .title {
      margin: 0;
      font-weight: bold;
      color: $samtek-black;
    }
  }

  .actions-section {
    display: flex;
    align-items: center;
    .dropdown-new-quote {
      padding-bottom: 2rem;
    }
  }
}

.breadcrumbs-ove {
  margin-bottom: 25px;
  font-size: 14px;
}

.tabs-wrapper {
  background: white;
  padding: 10px;
  border-radius: 8px;
  margin-bottom: 20px;

  .custom-tabs {
    display: flex;
    background: #f5f6fa;
    border-radius: 10px;
    padding: 5px;
    gap: 10px;

    .tab-item {
      flex: 1;
      text-align: center;
      padding: 8px;
      border-radius: 8px;
      cursor: pointer;
      transition: all 0.2s;

      .tab-label {
        font-weight: bold;
        color: $samtek-grey;
        font-size: 14px;
      }

      &:hover {
        background: rgba(0, 0, 0, 0.05);
      }

      &.active {
        background: $samtek-yellow;
        .tab-label {
          color: $samtek-black;
        }
      }
    }
  }
}

.table-wrapper {
  background: white;
  border-radius: 8px;
  padding: 15px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);

  ::v-deep .b-table {
    thead th {
      background-color: #dddde1;
      color: $samtek-grey;
      border: none;
      font-weight: bold;
    }

    tbody td {
      vertical-align: middle;
      border-bottom: 1px solid #f5f6fa;
      height: 70px;
    }
  }
}

.id-link {
  color: #1d4ed8;
  font-weight: bold;
  cursor: pointer;
  text-decoration: underline;

  &:hover {
    color: #1e40af;
  }
}

.btn-actions-ove {
  ::v-deep .btn {
    background-color: $samtek-yellow;
    border: none;
    color: $samtek-black;
    border-radius: 8px;
    height: 40px;
    padding: 0 15px;
    font-weight: 500;
    width: 130px;

    &:hover {
      background-color: darken($samtek-yellow, 5%);
    }
  }
}

.pagination-wrapper {
  margin-top: 20px;

  ::v-deep .page-item {
    &.active .page-link {
      background-color: $samtek-yellow;
      border-color: $samtek-yellow;
      color: $samtek-black;
    }
    .page-link {
      color: $samtek-black;
      border-radius: 4px;
      margin: 0 2px;
    }
  }
}

.primary-btn {
  background-color: $samtek-yellow;
  border: none;
  color: $samtek-black;
  font-weight: 500;
  padding: 8px 16px;
  border-radius: 8px;
}

::v-deep .dropdown-item {
  &:active,
  &.active,
  &:hover {
    background-color: $samtek-yellow !important;
    color: $samtek-black !important;
  }
}
</style>
